import { useState } from "react";
import { InputAdornment, TextField, Typography } from "@mui/material";
import type { TextFieldProps } from "@mui/material";

export const PasswordField = (props: Omit<TextFieldProps, "type">) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <TextField
            {...props}
            type={showPassword ? "text" : "password"}
            slotProps={{
                ...props.slotProps,
                input: {
                    endAdornment: (
                        <InputAdornment position="end">
                            <Typography
                                component="button"
                                type="button"
                                variant="body2"
                                onClick={() => setShowPassword((value) => !value)}
                                sx={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    fontWeight: 600,
                                    fontSize: "12px",
                                    color: "secondary.main",
                                    p: 0,
                                }}
                            >
                                {showPassword ? "Ocultar" : "Mostrar"}
                            </Typography>
                        </InputAdornment>
                    ),
                    ...(props.slotProps as any)?.input,
                },
            }}
        />
    );
};
